import editIndex from '@/views/edit/editIndex.vue'

export default {
  path: '/edit',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'editIndex',
      name: 'editIndex',
      component: editIndex
    },


  ]
}
